import React from 'react';
import { h1, h2, h3, h4, p } from '../../commonStyles/Fonts';
import { styled } from "../../../stitches.config";
import { ReactComponent as ArrowButton } from '../../../redesign/assets/icons/arrow-down.svg?react';

interface FaqCardProps {
    title: string,
    text: string,
}

const FaqCard = ({ title, text }: FaqCardProps) => {

    return (
        <Card>
            <summary><h4 className={h4()}>{title}</h4><ArrowButton /></summary>
            <p className={p()}>{text}</p>
        </Card>
    )
}

export default FaqCard;

const Card = styled('details', {
    'h4': {
        fontSize: '16px',
        margin: 0,
    },
    '@bp4': {
        'h4': {
            fontSize: '18px',
        },
    }
})